// extracted by mini-css-extract-plugin
export var dropdownButton = "_16-0";
export var fullWidthDropdownButton = "_16-1";
export var icon = "_16-3";
export var iconPlaceholder = "_16-2";
export var menuItemRow = "_16-9";
export var separator = "_16-e";
export var shortcutContainer = "_16-7";
export var shortcutContainerFilled = "_16-8";
export var shortcutIconLg = "_16-6";
export var shortcutIconMd = "_16-5";
export var shortcutIconSm = "_16-4";
export var submenuChevron = "_16-d";
export var submenuDropdown = "_16-a";
export var submenuTriggerRow = "_16-b";
export var submenuTriggerRowOpen = "_16-c";